var _g, _path, _rect, _rect2, _path2, _rect3, _rect4, _path3, _rect5, _rect6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskManagementCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22460_295791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6978 59.2816C63.744 59.1535 63.7612 59.0167 63.7481 58.8811C63.7349 58.7456 63.6917 58.6146 63.6217 58.4978L62.0951 55.9535C62.1315 55.4744 62.1319 54.9932 62.0962 54.514L63.6237 51.9682C63.6937 51.8518 63.7369 51.7213 63.7502 51.5861C63.7635 51.451 63.7465 51.3145 63.7005 51.1868C63.223 49.8697 62.5162 48.6474 61.6128 47.5766C61.525 47.4725 61.4151 47.3892 61.2911 47.3328C61.1671 47.2764 61.0321 47.2483 60.8959 47.2506L57.9292 47.3005C57.5325 47.0294 57.1159 46.7885 56.6831 46.5798L56.6846 46.5825L55.2421 43.984C55.1763 43.8652 55.0849 43.7625 54.9745 43.6834C54.8641 43.6043 54.7375 43.5508 54.6038 43.5268C53.2244 43.2818 51.8125 43.2828 50.4334 43.5297C50.2994 43.5537 50.1723 43.6072 50.0614 43.6864C49.9506 43.7655 49.8588 43.8684 49.7927 43.9875L48.3525 46.5818C47.9194 46.7898 47.5025 47.03 47.1053 47.3005L44.1371 47.2506C44.0006 47.2483 43.8653 47.2766 43.7412 47.3332C43.617 47.3898 43.507 47.4734 43.4191 47.5778C42.5185 48.6492 41.8143 49.8714 41.3391 51.1879C41.2928 51.316 41.2756 51.4528 41.2887 51.5884C41.3019 51.7239 41.3451 51.8549 41.4151 51.9717L42.9418 54.516C42.9054 54.9952 42.9049 55.4763 42.9406 55.9555L42.9422 55.9529L41.4131 58.5013C41.3431 58.6177 41.2999 58.7482 41.2866 58.8834C41.2733 59.0185 41.2903 59.155 41.3363 59.2827C41.8138 60.5998 42.5206 61.8221 43.424 62.8929C43.5118 62.997 43.6217 63.0803 43.7457 63.1367C43.8697 63.1931 44.0047 63.2212 44.1409 63.2189L47.1076 63.169C47.5044 63.4401 47.9209 63.681 48.3537 63.8897L48.3522 63.887L49.7947 66.4855C49.8605 66.6044 49.9519 66.707 50.0623 66.7861C50.1727 66.8652 50.2993 66.9187 50.433 66.9428C51.8124 67.1877 53.2243 67.1867 54.6034 66.9398C54.7375 66.9158 54.8645 66.8623 54.9754 66.7831C55.0862 66.704 55.178 66.6011 55.2441 66.482L56.6843 63.8877C57.1174 63.6797 57.5343 63.4395 57.9315 63.169L60.8998 63.2189C61.0362 63.2212 61.1715 63.1929 61.2957 63.1363C61.4199 63.0797 61.5299 62.9961 61.6177 62.8917C62.5183 61.8203 63.2225 60.5981 63.6978 59.2816ZM49.7748 59.9868C48.8349 59.4442 48.0771 58.635 47.5971 57.6617C47.1171 56.6883 46.9365 55.5945 47.0781 54.5185C47.2198 53.4425 47.6773 52.4327 48.3929 51.6168C49.1085 50.8008 50.0499 50.2154 51.0982 49.9345C52.1465 49.6536 53.2545 49.6899 54.2822 50.0387C55.3099 50.3876 56.2111 51.0333 56.8717 51.8943C57.5324 52.7553 57.9229 53.7929 57.9939 54.8759C58.0649 55.9588 57.8131 57.0385 57.2705 57.9784C56.9102 58.6024 56.4305 59.1494 55.8588 59.5881C55.2871 60.0267 54.6347 60.3485 53.9386 60.535C53.2426 60.7215 52.5166 60.7691 51.8022 60.675C51.0877 60.581 50.3988 60.3471 49.7748 59.9868Z",
    fill: "#E3EDC3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1053 47.3005C47.5024 47.03 47.9193 46.7898 48.3525 46.5818L49.7926 43.9875C49.8587 43.8684 49.9506 43.7656 50.0614 43.6864C50.1722 43.6072 50.2993 43.5537 50.4334 43.5297C51.8125 43.2828 53.2243 43.2818 54.6038 43.5268C54.7374 43.5508 54.8641 43.6043 54.9745 43.6834C55.0849 43.7625 55.1763 43.8652 55.2421 43.984L56.6845 46.5824L56.6831 46.5798C57.1159 46.7885 57.5324 47.0294 57.9291 47.3005L60.8959 47.2506C61.0321 47.2483 61.1671 47.2764 61.2911 47.3328C61.4151 47.3892 61.5249 47.4725 61.6127 47.5766C62.5161 48.6474 63.2229 49.8697 63.7005 51.1868C63.7465 51.3145 63.7635 51.451 63.7502 51.5861C63.7369 51.7213 63.6937 51.8518 63.6237 51.9682L62.0946 54.5166L62.0961 54.514C62.1318 54.9932 62.1314 55.4744 62.095 55.9535L63.6216 58.4978C63.6917 58.6146 63.7349 58.7456 63.748 58.8811C63.7612 59.0167 63.744 59.1535 63.6977 59.2816C63.2225 60.5981 62.5183 61.8203 61.6177 62.8917C61.5298 62.9961 61.4198 63.0797 61.2956 63.1363C61.1714 63.1929 61.0362 63.2212 60.8997 63.2189L57.9284 63.1689L57.9314 63.169C57.5343 63.4395 57.1174 63.6797 56.6842 63.8877L55.2441 66.482C55.178 66.6011 55.0862 66.704 54.9753 66.7831C54.8645 66.8623 54.7374 66.9158 54.6033 66.9398C53.2243 67.1867 51.8124 67.1877 50.433 66.9427C50.2993 66.9187 50.1727 66.8652 50.0622 66.7861C49.9518 66.707 49.8604 66.6043 49.7946 66.4855L48.3522 63.8871L48.3537 63.8897C47.9208 63.681 47.5043 63.4401 47.1076 63.169L44.1408 63.2189C44.0046 63.2212 43.8696 63.1931 43.7457 63.1367C43.6217 63.0803 43.5118 62.997 43.424 62.8929C42.5206 61.8221 41.8138 60.5998 41.3363 59.2827C41.2902 59.155 41.2733 59.0185 41.2865 58.8834C41.2998 58.7482 41.343 58.6177 41.413 58.5013L42.9421 55.9529L42.9406 55.9555C42.9049 55.4763 42.9053 54.9951 42.9417 54.516L41.4151 51.9717C41.345 51.8549 41.3018 51.7239 41.2887 51.5884C41.2755 51.4528 41.2927 51.316 41.339 51.1879C41.8142 49.8714 42.5184 48.6492 43.4191 47.5778C43.5069 47.4734 43.6169 47.3898 43.7411 47.3332C43.8653 47.2766 44.0005 47.2483 44.137 47.2505L47.1083 47.3006L47.1053 47.3005Z",
    stroke: "#274642",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7747 59.9868C52.3992 61.5021 55.7552 60.6029 57.2704 57.9784C58.7857 55.3539 57.8865 51.9979 55.262 50.4827C52.6375 48.9674 49.2815 49.8666 47.7663 52.4911C46.251 55.1156 47.1502 58.4716 49.7747 59.9868Z",
    stroke: "#274642",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.2656 39.3281V16.3281C54.2656 15.7758 53.8179 15.3281 53.2656 15.3281H19.2656C18.7133 15.3281 18.2656 15.7758 18.2656 16.3281V62.3281C18.2656 62.8804 18.7133 63.3281 19.2656 63.3281H38.7656",
    stroke: "#274642",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.1656,
    y: 22.7281,
    width: 6.2,
    height: 6.2,
    rx: 1.1,
    fill: "#E3EDC3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1656,
    y: 22.7281,
    width: 6.2,
    height: 6.2,
    rx: 1.1,
    stroke: "#274642",
    strokeWidth: 1.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2656 25.8281H48.2656",
    stroke: "#274642",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1656,
    y: 34.7281,
    width: 6.2,
    height: 6.2,
    rx: 1.1,
    fill: "#E3EDC3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1656,
    y: 34.7281,
    width: 6.2,
    height: 6.2,
    rx: 1.1,
    stroke: "#274642",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2656 37.8281H48.2656",
    stroke: "#274642",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1656,
    y: 46.7281,
    width: 6.2,
    height: 6.2,
    rx: 1.1,
    fill: "#E3EDC3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1656,
    y: 46.7281,
    width: 6.2,
    height: 6.2,
    rx: 1.1,
    stroke: "#274642",
    strokeWidth: 1.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22460_295791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(38.7344 41.6719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskManagementCard);
export default __webpack_public_path__ + "static/media/task_management_card.0757e236347811f9cd9c10ecf1465930.svg";
export { ForwardRef as ReactComponent };